const BASE_URL = "https://www.vagaro.com/";
const PRO_PATH = "pro/";

/**
 * Exact mapping of known business types (from /facilities endpoint) to their primary
 * vagaro.com/pro/ sales page slug. Keys are lowercase versions of the API values.
 * The business type name itself is used as the link display text.
 */
const BUSINESS_TYPE_MAP: Record<string, string> = {
    // Wellness
    "spa":                      "spa-software",
    "medical spa":              "medical-spa-software",
    "massage":                  "massage-software",
    "acupuncture":              "acupuncture-software",
    "holistic therapy":         "spa-software",
    "cryotherapy":              "spa-software",
    "physical therapy":         "physical-therapy-software",
    "chiropractor":             "chiropractor-software",
    "nutritionist":             "nutritionist-software",
    "mental health":            "mental-health-software",
    "ultrasound":               "medical-spa-software",
    "body enhancement":         "medical-spa-software",
    "life & wellness coaching": "coaching-software",
    "weight loss":              "medical-spa-software",

    // Beauty — Hair
    "hair":                     "salon-software",
    "braids":                   "salon-software",
    "hair replacement":         "salon-software",
    "locs":                     "salon-software",
    "textured hair":            "salon-software",
    "hair extensions":          "salon-software",

    // Beauty — Face & Body
    "lashes":                   "brow-lash-software",
    "brows":                    "brow-lash-software",
    "nails":                    "nail-salon-software",
    "skin care":                "beauty-software",
    "makeup":                   "makeup-artist-software",
    "permanent makeup":         "makeup-artist-software",
    "microblading":             "makeup-artist-software",
    "tanning":                  "tanning-salon-software",
    "barber":                   "barber-software",
    "waxing":                   "beauty-software",
    "sugaring":                 "beauty-software",
    "threading":                "beauty-software",
    "teeth whitening":          "beauty-software",

    // Beauty — Specialty
    "laser hair removal":       "hair-removal-studio-software",
    "electrolysis":             "hair-removal-studio-software",
    "tattoos":                  "tattoo-shop-software",
    "tattoo removal":           "medical-spa-software",
    "piercing":                 "tattoo-shop-software",
    "pet grooming":             "pet-grooming-software",

    // No dedicated sales page — link to /pro
    "photo studio":             "",
    "auto detailing":           "",
    "jewelry":                  "",
    "other":                    "",

    // Fitness
    "personal trainer":         "personal-training-software",
    "yoga":                     "yoga-software",
    "fitness studio":           "fitness-software",
    "pilates":                  "pilates-software",
    "gyrotonic":                "fitness-software",
    "tennis":                   "fitness-software",
    "dance studio":             "dancing-studio-software",
    "swimming":                 "fitness-software",
    "equestrian":               "fitness-software",
    "cycling":                  "cycling-software",
    "golf":                     "fitness-software",
    "martial arts":             "martial-arts-software",
    "sports training":          "fitness-software",
    "rock climbing":            "fitness-software",
    "pickleball":               "fitness-software",
};

export interface BacklinkInfo {
    label: string;
    url: string;
}

const MAX_BACKLINKS = 3;

/**
 * Returns an array of backlink info for unique sales pages across all business types.
 * Capped at MAX_BACKLINKS to keep the footer single-line on mobile.
 * Uses the business type name as the link label and deduplicates by slug
 * so the same sales page isn't linked twice.
 */
export function getAllBacklinks(businessType: string | undefined,local:string|undefined): BacklinkInfo[] {
    if (!businessType) return [];

    const types = businessType.split(",").map((t) => t.trim()).filter(Boolean);
    const seen = new Set<string>();
    const results: BacklinkInfo[] = [];
    const useLocale = local||""

    for (const type of types) {
        const slug = BUSINESS_TYPE_MAP[type.toLowerCase()];
        if (slug !== undefined && !seen.has(slug)) {
            seen.add(slug);
            results.push({
                label: slug.replaceAll("-", " ").replace(/\b\w/g, (c) => c.toUpperCase()), // Convert slug to title case for label
                url: `${BASE_URL}${useLocale}${PRO_PATH}${slug}`,
            });
            if (results.length >= MAX_BACKLINKS) return results;
        }
    }

    return results;
}
